
export default function convertHierarchyToOTUTable(hierarchyData) {
    const otuTable = [];
    const rankOrder = ['sk', 'k', 'p', 'c', 'o', 'f', 'g', 's'];
    const rankNames = {
        'sk': 'superkingdom',
        'k': 'kingdom',
        'p': 'phylum',
        'c': 'class',
        'o': 'order',
        'f': 'family',
        'g': 'genus',
        's': 'species'
    };

    // total count from root node
    const totalCount = hierarchyData.count;
    // console.log('totalCount:', totalCount);


    function traverseHierarchy(node, currentTaxonomy = []) {
        const currentRankIndex = rankOrder.indexOf(node.rank);

        if (currentRankIndex > 0) {
            const lastTaxonRank = currentTaxonomy.length > 0
                ? rankOrder.indexOf(currentTaxonomy[currentTaxonomy.length - 1].split('__')[0])
                : -1;

            for (let i = lastTaxonRank + 1; i < currentRankIndex; i++) {
                currentTaxonomy.push(`${rankOrder[i]}__`);
            }
        }

        const taxonName = `${node.rank}__${node.name}`;
        currentTaxonomy.push(taxonName);

        // relative abundance
        const relativeAbundance = (node.count / totalCount);
        // console.log(node.count);


        otuTable.push({
            count: node.count,
            abundance: relativeAbundance.toFixed(10),
            taxon: currentTaxonomy.join(';')
        });

        if (node.children) {
            node.children.forEach(child => traverseHierarchy(child, [...currentTaxonomy]));
        }
    }

    traverseHierarchy(hierarchyData, []);

    otuTable.sort((a, b) => a.taxon.localeCompare(b.taxon));

    return otuTable;
}


// export default function convertHierarchyToOTUTable(hierarchyData) {
//     const otuTable = [];
//     const rankOrder = ['sk', 'k', 'p', 'c', 'o', 'f', 'g', 's'];

//     function traverseHierarchy(node, currentTaxonomy = []) {
//         const currentRankIndex = rankOrder.indexOf(node.rank);

//         // Fill in missing intermediate ranks with empty placeholders
//         if (currentRankIndex > 0) {
//             const lastTaxonRank = currentTaxonomy.length > 0
//                 ? rankOrder.indexOf(currentTaxonomy[currentTaxonomy.length - 1].split('__')[0])
//                 : -1;

//             for (let i = lastTaxonRank + 1; i < currentRankIndex; i++) {
//                 currentTaxonomy.push(`${rankOrder[i]}__`);
//             }
//         }

//         // Add current taxon
//         const taxonName = `${node.rank}__${node.name.replace(/ /g, '_')}`;
//         currentTaxonomy.push(taxonName);

//         // Add entry to OTU table
//         otuTable.push({
//             count: node.count,
//             abundance: (node.count / hierarchyData.count).toFixed(10),
//             taxon: currentTaxonomy.join(';')
//         });

//         // Process children
//         if (node.children && node.children.length > 0) {
//             node.children.forEach(child => traverseHierarchy(child, [...currentTaxonomy]));
//         }
//     }

//     traverseHierarchy(hierarchyData, []);

//     // Sort by taxonomic hierarchy
//     otuTable.sort((a, b) => a.taxon.localeCompare(b.taxon));

//     return otuTable;
// }